import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowshoeNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M3.165 0a2.625 2.625 0 00-2.37 1.496l-.086.181A7.292 7.292 0 000 4.814v3.882c0 1.037 0 2.776.379 4.266.19.753.492 1.501.987 2.07.515.592 1.221.968 2.134.968s1.62-.377 2.134-.968c.495-.569.796-1.317.987-2.07.38-1.49.379-3.229.379-4.266V4.814a7.292 7.292 0 00-.709-3.137l-.087-.181A2.625 2.625 0 003.834 0zM1.924 2.034a1.375 1.375 0 011.241-.784h.67c.53 0 1.013.305 1.241.784l.087.181c.386.812.587 1.7.587 2.599V5h-4.5v-.186c0-.9.2-1.787.587-2.599zM1.25 7.036l1.43 1.691-.26.31a1.267 1.267 0 00.07 1.713c.558.557 1.461.557 2.018 0 .466-.466.497-1.21.072-1.714l-.262-.309L5.75 7.035V8.67c0 1.062-.003 2.659-.34 3.985-.168.661-.406 1.196-.72 1.557-.294.338-.665.538-1.19.538s-.896-.2-1.19-.538c-.314-.36-.552-.896-.72-1.557-.337-1.326-.34-2.923-.34-3.985zm.972-.786h2.555L3.5 7.76zM15.204 1.496A2.625 2.625 0 0012.834 0h-.669a2.625 2.625 0 00-2.37 1.496l-.086.181A7.292 7.292 0 009 4.814v3.882c0 1.037 0 2.776.379 4.266.19.753.492 1.501.987 2.07.515.592 1.222.968 2.134.968s1.62-.377 2.134-.968c.495-.569.796-1.317.987-2.07.38-1.49.379-3.229.379-4.266V4.814a7.291 7.291 0 00-.709-3.137zm-2.37-.246c.531 0 1.014.305 1.242.784l.086.181c.387.812.588 1.7.588 2.599V5h-4.5v-.186c0-.9.2-1.787.587-2.599l.087-.181a1.375 1.375 0 011.241-.784zM10.25 8.67V7.036l1.431 1.691-.261.31a1.266 1.266 0 00.071 1.713c.557.557 1.46.557 2.018 0 .466-.466.497-1.21.071-1.714l-.261-.309 1.431-1.691V8.67c0 1.062-.003 2.659-.34 3.984-.168.662-.406 1.197-.72 1.558-.294.338-.665.538-1.19.538s-.896-.2-1.19-.538c-.314-.36-.552-.896-.72-1.558-.337-1.325-.34-2.922-.34-3.984zm2.25-.91l-1.277-1.51h2.554z" />
      </g>
    </svg>
  )
);
SvgSportsSnowshoeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowshoeNormalXsmall;
